import * as React from "react";
import { forwardRef } from "react";
const SvgTargetIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 4, fill: "#EAECF0" }), /* @__PURE__ */ React.createElement("rect", { x: 0.75, y: 0.75, width: 22.5, height: 22.5, rx: 11.25, stroke: "#EAECF0", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgTargetIcon);
export { ForwardRef as ReactComponent };
